// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"319":"5a215ec7","602":"af33b3b5"}[chunkId] + ".chunk.css";
};